import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { FileText, Images } from "lucide-react";

export const fileUrl = (path) => `${API}/files/${path}?auth=${localStorage.getItem("contaha_token")}`;
const isImg = (f) => (f.content_type || "").startsWith("image/");

function Thumb({ f, onOpen }) {
  return (
    <div className="w-36 shrink-0" data-testid={`file-${f.id}`}>
      <button type="button" onClick={() => onOpen(f)} className="block h-24 w-36 overflow-hidden rounded-lg border border-[#E2E8F0] bg-black dark:border-[#223139]">
        {isImg(f) ? <img src={fileUrl(f.storage_path)} alt={f.original_filename} className="h-full w-full object-cover" loading="lazy" />
          : <span className="flex h-full items-center justify-center bg-[#F4FBF7] text-[#00A85A]"><FileText className="h-8 w-8" /></span>}
      </button>
      <div className="mt-1 break-words text-[#101516] dark:text-white">{f.modality || f.image_type || "File"}{f.annotated_path ? " · annotated" : ""}</div>
      <div className="break-all text-[#8B9698]">{f.original_filename}</div>
    </div>
  );
}

export function FileGallery({ consultationId, files: given, title = "Uploaded images & files", testid = "file-gallery" }) {
  const [files, setFiles] = useState(given || null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    if (given) { setFiles(given); return; }
    if (consultationId) { api.get("/imaging", { params: { consultation_id: consultationId } }).then((r) => setFiles(r.data)).catch(() => setFiles([])); }
  }, [consultationId, given]);
  return (
    <section className="mb-6 rounded-2xl border border-[#E2E8F0] bg-white p-5 dark:border-[#223139] dark:bg-[#0E1A21]" data-testid={testid}>
      <h3 className="mb-3 flex items-center gap-2 font-bold text-[#101516] dark:text-white"><Images className="h-4 w-4 text-[#00A85A]" />{title} ({(files || []).length})</h3>
      {(files || []).length ? <div className="flex gap-3 overflow-x-auto pb-1">{files.map((f) => <Thumb key={f.id} f={f} onOpen={setOpen} />)}</div>
        : <p className="text-[#8B9698]">No files attached to this consultation.</p>}
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-h-[92vh] max-w-4xl overflow-y-auto" data-testid="file-viewer">
          <DialogHeader><DialogTitle className="break-all">{open?.original_filename}</DialogTitle><DialogDescription>{open?.modality || open?.image_type || "File"} · {open?.created_at?.slice(0, 10)}</DialogDescription></DialogHeader>
          {open && (isImg(open) ? (
            <div className="space-y-3">
              <img src={fileUrl(open.storage_path)} alt="Original" className="w-full rounded-lg" />
              {open.annotated_path && <><div className="font-semibold">Annotated copy</div><img src={fileUrl(open.annotated_path)} alt="Annotated" className="w-full rounded-lg" data-testid="file-viewer-annotated" /></>}
            </div>
          ) : <a href={fileUrl(open.storage_path)} target="_blank" rel="noreferrer" className="font-semibold text-[#00A85A] underline">Open file</a>)}
        </DialogContent>
      </Dialog>
    </section>
  );
}
